export default __webpack_public_path__ + "static/media/dollar.6a41cfe2.svg";